import { hideModal } from '../globalState'
import { appQueryParams } from '../appParams'
import { useIsModalActive } from './utilsApp'
import Screen from './Screen'
import LoadingTimer from './LoadingTimer'
import ReplayPauseMenu from './ReplayPauseMenu'
import styles from './PauseScreen.module.css'

export default () => {
  const lockConnect = appQueryParams.lockConnect === 'true'
  const isModalActive = useIsModalActive('pause-screen')
  if (!isModalActive) return null

  return (
    <Screen
      title=''
      className={`wide-screen ${styles.pauseScreen}`}
    >
      <ReplayPauseMenu onReturnPress={() => hideModal({ reactType: 'pause-screen' })} lockConnect={lockConnect} />
      <LoadingTimer />
    </Screen>
  )
}
